import React, { useState } from 'react';
import { db } from '../firebase';
import { collection, addDoc, getDocs } from 'firebase/firestore';

const FirebaseTest = () => {
  const [status, setStatus] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const testConnection = async () => {
    setIsLoading(true);
    setStatus('Firebase 연결 테스트 중...');
    
    try {
      // 간단한 테스트 문서 추가
      const testCollection = collection(db, 'test');
      const docRef = await addDoc(testCollection, {
        message: 'Firebase 연결 테스트',
        timestamp: new Date()
      });
      
      setStatus(`✅ Firebase 연결 성공! 문서 ID: ${docRef.id}`);
      
      // 테스트 문서 읽기
      const snapshot = await getDocs(testCollection);
      setStatus(prev => prev + `\n📊 총 ${snapshot.docs.length}개 문서 발견`);
      
    } catch (error) {
      console.error('Firebase 테스트 에러:', error);
      setStatus(`❌ Firebase 연결 실패: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={{ padding: '20px', backgroundColor: '#f8f9fa', borderRadius: '8px', margin: '20px' }}>
      <h3>Firebase 연결 테스트</h3>
      <button 
        onClick={testConnection} 
        disabled={isLoading}
        style={{
          padding: '10px 20px',
          backgroundColor: isLoading ? '#ccc' : '#0066cc',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: isLoading ? 'not-allowed' : 'pointer'
        }}
      >
        {isLoading ? '테스트 중...' : 'Firebase 연결 테스트'}
      </button>
      {status && (
        <pre style={{ 
          marginTop: '10px', 
          padding: '10px', 
          backgroundColor: 'white', 
          border: '1px solid #ddd',
          borderRadius: '4px',
          whiteSpace: 'pre-wrap'
        }}>
          {status}
        </pre>
      )}
    </div>
  );
};

export default FirebaseTest;
